export enum BadgeType {
    EXPLORER_BADGE = "Explorer Badge",
    COMPLETION_BADGE = "Completion Badge",
    SPEED_BADGE = "Speed Badge"
}